import BaseImage from "@components/BaseImage";
import UTMLink from "@components/UTMLink";
import { BRIDGE_TO_CHAIN } from "@constants/analytics";
import { BRIDGE_AGETH_OPTIONS, BRIDGE_OPTIONS } from "@constants/common";
import {
  Button,
  Card,
  Input,
  Typography,
} from "@kelp-dao/kernel-design-system";
import { formatNumber, trackEvent } from "utils";
import { TChainSelection } from "../BridgeWrap/types";

const BridgeAccordionV2 = ({
  isAgETH = false,
  toSymbol,
  fromSymbol,
  fromChain,
  toChain,
  tokenAmount,
}: {
  isAgETH?: boolean;
  toSymbol: string;
  fromSymbol: string;
  fromChain: TChainSelection;
  toChain: TChainSelection;
  tokenAmount?: number | null;
}) => {
  const BRIDGE_CONFIG = isAgETH ? BRIDGE_AGETH_OPTIONS : BRIDGE_OPTIONS;
  const bridgeConfigFrom = BRIDGE_CONFIG.filter(
    (v) => v.id === fromChain.id
  )[0];

  let bridgeConfigTo;
  if (toChain.id === 1) {
    bridgeConfigTo = BRIDGE_CONFIG.filter((v) => v.id === 1)[0];
  }
  // KSP-561, KSP-562, KSP-563 - for linea, optimism & zircuit
  else if (
    fromChain.id === 59144 ||
    fromChain.id === 10 ||
    fromChain.id === 48900
  ) {
    bridgeConfigTo = BRIDGE_CONFIG.filter((v) => v.id === toChain.id)[0];
  } else {
    bridgeConfigTo = BRIDGE_CONFIG.filter((v) => v.id === toChain.id)[0];
  }

  return (
    <Card
      variant="non-bordered"
      className="w-full p-4 md:p-8 flex flex-col gap-5 rounded-2xl"
    >
      <div className="flex flex-col md:flex-row justify-between gap-4">
        <div className="flex flex-col gap-1 w-full">
          <Typography
            variant="xsmall"
            type="body"
            className="text-text-secondary"
          >
            From
          </Typography>
          <Input
            value={fromSymbol}
            onChange={() => {}}
            placeholder="Enter amount"
            disabled
            containerClassName="w-full"
            inputClassName=""
            rightElementClassName="bg-bg-primary bg-opacity-50"
            rightElement={
              <Typography
                variant="small"
                type="body"
                className="text-text-secondary"
              >
                on {bridgeConfigFrom?.to || fromChain.title}
              </Typography>
            }
          />
          <Typography
            variant="small"
            type="body"
            className="text-text-secondary"
          >
            Balance:{" "}
            <strong>
              {formatNumber(Number(tokenAmount), false, 4, true)} {fromSymbol}
            </strong>
          </Typography>
        </div>
        <div className="flex flex-col gap-1 w-full">
          <Typography
            variant="xsmall"
            type="body"
            className="text-text-secondary"
          >
            To
          </Typography>
          <Input
            value={toSymbol}
            onChange={() => {}}
            placeholder="Enter amount"
            disabled
            containerClassName="w-full"
            inputClassName=""
            rightElementClassName="bg-bg-primary bg-opacity-50"
            rightElement={
              <Typography
                variant="small"
                type="body"
                className="text-text-secondary"
              >
                on {bridgeConfigTo?.to || toChain.title}
              </Typography>
            }
          />
        </div>
      </div>
      <div className="flex justify-between gap-1">
        <Typography variant="small" type="body" className="text-text-secondary">
          Est. time to bridge
        </Typography>
        <Typography variant="small" type="body" className="text-text-primary">
          ~10 Mins
        </Typography>
      </div>
      {bridgeConfigTo && bridgeConfigTo.link && (
        <UTMLink
          href={
            (fromChain.id === 59144 ||
              fromChain.id === 10 ||
              fromChain.id === 48900) &&
            toChain.id === 1
              ? BRIDGE_CONFIG.filter((v) => v.id === fromChain.id)[0]?.link ||
                bridgeConfigTo.link
              : bridgeConfigTo.link
          }
          isExternal={true}
          onClick={() =>
            trackEvent(BRIDGE_TO_CHAIN, { chain_clicked: toChain })
          }
        >
          <Button
            variant="primary"
            icon={
              <BaseImage
                src={bridgeConfigFrom?.icon || ""}
                alt={bridgeConfigFrom?.to || ""}
                width={18}
                height={18}
              />
            }
            className="w-full"
          >
            Go to Bridge
          </Button>
        </UTMLink>
      )}
    </Card>
  );
};

export default BridgeAccordionV2;
